/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useState, useEffect } from "react";
import { Link, useLocation, useParams } from "react-router-dom";

// third-party imports
import FsLightbox from "fslightbox-react";

// project-imports
import { slugify } from "../../utils";
import { GoogleAnalyticsEnum, pageView, triggerFunction, } from "../../utils/google-analytics";
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import Spinner from "../../components/spinner-component/SpinnerOne";
import BreadcrumbOne from "../../common/breadcrumb/BreadcrumbOne";
import { useProductContext } from "../../context/product_context";
import EBookInfo from "../../components/ebooks/EBookInfo";
import { FREE, PAID } from "../../constants";
import { calculateAverageRating } from "../../utils/product";
import { numberFormatter } from "../../utils/course";
import SectionTitle from "../../components/sectionTitle/SectionTitle";
import EBookWidget from "../../components/reusable/widgets/EBookWidget";
import ReusableWidget from "../../components/reusable/widgets/ReusableWidget";
import { useGalleryContext } from "../../context/gallery_context";
import GalleryDrawer from "../../components/our-gallery/GalleryDrawer";
import InterviewRelatedSeries from "../../components/interview-questions/interview-series/InterviewRelatedSeries";
import { useInterviewContext } from "../../context/interview_context";

const EBookDetails = () => {

    // Extracting methods and variables form the context
    const { ebooks, productLoading } = useProductContext();
    const { popularVideos, popularShorts, popularLiveVideos, lastWeekTrendingVideos, latestVideos, galleryLoading } = useGalleryContext();
    const { interviewSeries } = useInterviewContext();

    // Property initialization
    const { type, productCode } = useParams();
    const location = useLocation();

    // Consant variable
    const ebookProductCode = productCode || "";
    const ebookType = type || "";
    const data = (ebooks || [])?.filter((item) => {
        const currentBookType = item?.pricing?.price > 0 ? PAID : FREE;
        return currentBookType === ebookType && item?.productCode?.toLowerCase() === ebookProductCode;
    }) || [];

    const ebookItem = data && data[0] && (data[0] || {});

    const metaDataObject = ebookItem && ebookItem?.metadata ? ebookItem?.metadata : {};
    const metaDataTags =
        metaDataObject && metaDataObject?.tags ? metaDataObject?.tags : "";
    const resourceFeatures =
        ebookItem && ebookItem?.features && ebookItem?.features?.length ? ebookItem?.features : [];
    const tags = metaDataTags.split(/[,\s]+/);
    const latestVideosData = latestVideos && latestVideos?.length && latestVideos ? latestVideos : [];
    const popularVideosData = popularVideos && popularVideos?.length && popularVideos ? popularVideos : [];
    const popularShortsVideosData = popularShorts && popularShorts?.length && popularShorts ? popularShorts : [];

    const seriesData = interviewSeries && interviewSeries?.length ? interviewSeries : [];
    const seriesName = seriesData?.map((i) => i?.name || "");

    // State initalization
    const [contentTab, setContentTab] = useState("overview");
    const [toggler, setToggler] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const [openDrawer, setOpenDrawer] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const ebookTitleForAnalytics = ebookItem
        ? GoogleAnalyticsEnum.SF_EBOOK_DETAIL_VIEW + " " + ebookItem?.name
        : "Default E-Book";

    // Dynamic Css for star Rating End

    // const reviews = JSON.stringify(ProductRatingData);
    const reviews =
        ebookItem && ebookItem?.metadata && ebookItem?.metadata?.ratings && ebookItem?.metadata?.ratings !== "0"
            ? ebookItem?.metadata?.ratings
            : "[]";

    // this will remove the tralling commas as there is the comma that making error on pars so used this to clean the string
    let cleanString = reviews?.replace(/,\s*([}\]])/g, "$1");
    const review = JSON.parse(cleanString);

    // variabel for overallRatings
    const overAllAverageRatings = calculateAverageRating(review);

    //RatingSummary
    const buildRatingSummary = (reviews = []) => {
        try {
            const summary = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };

            reviews?.forEach((review) => {
                summary[review?.rating] += 1;
            });

            return summary;
        } catch (error) { }
    };
    const ratingSummary = buildRatingSummary(review);
    //constant variabel for totalreviews
    const totalReviews = review?.length;
    //getProgresswidth in rarings
    const getProgressWidth = (count, total) => {
        return total > 0 ? (count / total) * 100 : 0;
    };

    // Dynamic Css for star Rating Start (Added By Longswitch Team)
    const halfIconDynamicStyle = (rating) => {
        let ratings = Number((rating - Math.floor(rating)) * 100).toFixed(2);

        return {
            "--width": `${ratings}%`,
            "--rating-percent": `${100 - ratings}%`,
        };
    };


    // Constant functions
    const handleTab = (content) => {
        if (content === "overview") {
            setContentTab("overview");
        } else if (content === "reviews") {
            setContentTab("reviews");
        }
    };

    const handleVideoToggle = (url) => {
        try {
            setVideoUrl(url);
            setToggler(!toggler);
        } catch (error) { }
    };

    const handleOpenDrawer = (data) => {
        try {
            setOpenDrawer(true);
            setSelectedItem(data);
            triggerFunction(
                GoogleAnalyticsEnum.BUTTON,
                GoogleAnalyticsEnum.SF_TUTORIALS_DETAIL_VIEW,
            );
        } catch (error) {
            console.log(
                "49 : HomeFourBlog : Error in handleOpenDrawer : ",
                error && JSON.stringify(error),
            );
        }
    };

    const handleHideDrawer = () => {
        try {
            setOpenDrawer(false);
        } catch (error) {
            console.log(
                "60 : HomeFourBlog : Error in handleHideDrawer : ",
                error && JSON.stringify(error),
            );
        }
    };


    useEffect(() => {
        //  Get hash from URL
        const hash = location.hash;

        if (hash) {
            const tabName = hash.replace('#', '');
            if (tabName) {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth' // Use 'auto' for an instant jump instead of smooth scrolling
                });
                setContentTab(tabName);
            }
        }
    }, []);



    return (
        <>
            <SEO title={ebookItem?.name || "Default E-Book Title"} url={process.env.PUBLIC_URL + `/our-resources/${ebookType}/${slugify(ebookItem?.name || "Default E-Book Title")}`} image={ebookItem?.image} />  {/* Set SEO title */}
            {pageView(window.location.pathname, ebookTitleForAnalytics)}
            {productLoading && <Spinner />}  {/* Loading spinner */}
            <Layout searchDisable={true}>
                <BreadcrumbOne
                    title={ebookItem?.name} // Breadcrumb title 
                    rootUrl="/"
                    parentUrl="Home"
                    googleEnum={GoogleAnalyticsEnum.SALESFORCE_EBOOK_DETAILS_TO_HOME}
                    currentUrl="E-Book Details"
                />
                <div className="edu-course-details-area pt--40 pb--140 bg-color-white">
                    <div className="container">

                        <SectionTitle
                            classes="text-start"
                            slogan="Our Resources"
                            title={ebookItem?.name}
                        />

                        <div className="row g-5 pt--40">
                            <div className="col-12 col-xl-8 col-lg-7">
                                <div className="course-details-content">

                                    <ul className="edu-course-tab nav nav-tabs justify-content-start" role="tablist">
                                        <li className="nav-item">
                                            <button
                                                className={
                                                    contentTab === "overview"
                                                        ? "nav-link active"
                                                        : "nav-link"
                                                }
                                                type="button"
                                                aria-label="Overview"
                                                data-target="overview"
                                                onClick={() => {
                                                    handleTab("overview");
                                                    triggerFunction(
                                                        GoogleAnalyticsEnum.BUTTON,
                                                        GoogleAnalyticsEnum.SALESFORCE_EBOOK_DETAILS_OVERVIEW_BUTTON
                                                    );
                                                }}
                                            >
                                                Overview
                                            </button>
                                        </li>
                                        {review && review?.length ?
                                            <li className="nav-item">
                                                <button
                                                    className={contentTab === 'reviews' ? 'nav-link active' : 'nav-link'}
                                                    type="button"
                                                    aria-label="Reviews"
                                                    data-target="reviews"
                                                    onClick={() => { handleTab('reviews'); triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.SALESFORCE_EBOOK_DETAILS_REVIEWS_BUTTON) }}
                                                >
                                                    Reviews
                                                </button>
                                            </li>
                                            :
                                            <></>
                                        }
                                    </ul>

                                    <div className="tab-content">
                                        {contentTab === "overview" && (
                                            <div
                                                className={`tab-pane fade show ${contentTab === "overview" ? "active" : ""
                                                    } `}
                                            >
                                                <div className="col-12 pt-5">
                                                    <div className="row px-4">
                                                        {/* <div className="col-12 text-start">
                                                            <div className="fw-bold fs-2">Description</div>
                                                        </div> */}
                                                        <div className="col-12 text-start">
                                                            <p className="m-0" dangerouslySetInnerHTML={{ __html: ebookItem?.description }}></p>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* {resourceFeatures && (
                                                    <div className="col-12">
                                                        <div className="row px-4">
                                                            <div className="col-12 text-start">
                                                                <div className="fw-bold text-dark fs-2">Features</div>
                                                            </div>
                                                            <div className="col-12 text-start mb-2">
                                                                <ul className="mb-0">
                                                                    {(resourceFeatures || [])?.map((item, i) => (
                                                                        <li key={i}>{item}</li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )} */}

                                                {tags && tags?.length && (
                                                    <div className="col-12">
                                                        <div className="row px-4">
                                                            <div className="col-12 text-start">
                                                                <div className="fw-bold text-dark fs-2">Tags</div>
                                                            </div>
                                                            <div className="rating eduvibe-course-rating-stars mt-0 text-start">
                                                                {(tags || [])?.map((item, i) => (
                                                                    <span
                                                                        class="fs-5 badge text-success rounded-pill bg-success bg-opacity-25 text-capitalize mx-1"
                                                                        key={i}
                                                                    >
                                                                        {item}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {review && review?.length && review ? (
                                            <>
                                                {contentTab === "reviews" && (
                                                    <div
                                                        className={`tab-pane fade show ${contentTab === "reviews" ? "active" : ""
                                                            } `}
                                                    >
                                                        <div className="course-details-content tab-content">
                                                            <div className={`tab-pane fade show active `}>
                                                                <div className="course-tab-content">
                                                                    <div className="row row--30">
                                                                        <div className="col-lg-5">
                                                                            <div className="rating-box">
                                                                                <div className="rating-number">
                                                                                    {overAllAverageRatings}
                                                                                </div>
                                                                                <div className="rating eduvibe-course-rating-stars">
                                                                                    {[...Array(5)].map((rate, index) => {
                                                                                        const givenRating = index + 1;
                                                                                        return (
                                                                                            <i
                                                                                                className={
                                                                                                    overAllAverageRatings >= givenRating
                                                                                                        ? "icon-Star"
                                                                                                        : overAllAverageRatings > givenRating - 1 &&
                                                                                                            overAllAverageRatings < givenRating
                                                                                                            ? " icon-Star-half "
                                                                                                            : " off icon-Star"
                                                                                                }
                                                                                                key={index}
                                                                                                style={halfIconDynamicStyle(
                                                                                                    overAllAverageRatings
                                                                                                )}
                                                                                            ></i>
                                                                                        );
                                                                                    })}
                                                                                </div>
                                                                                <span>({totalReviews} Ratings)</span>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-7">
                                                                            <div className="review-wrapper">
                                                                                {[5, 4, 3, 2, 1].map((star) => {
                                                                                    const count = ratingSummary[star];
                                                                                    const width = getProgressWidth(count, totalReviews);

                                                                                    return (
                                                                                        <div className="single-progress-bar" key={star}>
                                                                                            <div className="rating-text">
                                                                                                {star} <i className="icon-Star"></i>
                                                                                            </div>

                                                                                            <div className="progress">
                                                                                                <div
                                                                                                    className="progress-bar"
                                                                                                    role="progressbar"
                                                                                                    style={{ width: `${width}%` }}
                                                                                                    aria-valuenow={width}
                                                                                                    aria-valuemin="0"
                                                                                                    aria-valuemax="100"
                                                                                                />
                                                                                            </div>

                                                                                            <span className="rating-value">
                                                                                                {numberFormatter?.format(count)}
                                                                                                <span className="rating-persentage">
                                                                                                    ({width?.toFixed(0)}%)
                                                                                                </span>
                                                                                            </span>
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="comment-wrapper pt--40">
                                                                        <div className="section-title">
                                                                            <h5 className="mb--25">Reviews</h5>
                                                                        </div>
                                                                        {/* Review Section */}
                                                                        {review &&
                                                                            review?.length &&
                                                                            review.map((item, i) => (
                                                                                <div className="edu-comment">
                                                                                    <div className="thumbnail">
                                                                                        <Link to={item.linkedIn} target="_blank">
                                                                                            <img
                                                                                                src="/images/course/student-review/linkedin_logo.png"
                                                                                                alt="Student Thumb"
                                                                                            />
                                                                                        </Link>
                                                                                    </div>
                                                                                    <div className="comment-content">
                                                                                        <div className="comment-top">
                                                                                            <h6 className="title">
                                                                                                {item?.userName || "Guest User"}
                                                                                            </h6>
                                                                                            <div className="rating eduvibe-course-rating-stars">

                                                                                                {[...Array(5)].map((rate, index) => {
                                                                                                    const givenRating = index + 1;
                                                                                                    return (
                                                                                                        <i
                                                                                                            className={
                                                                                                                item?.rating >= givenRating
                                                                                                                    ? "icon-Star"
                                                                                                                    : item?.rating > givenRating - 1 &&
                                                                                                                        item?.rating < givenRating
                                                                                                                        ? " icon-Star-half "
                                                                                                                        : " off icon-Star"
                                                                                                            }
                                                                                                            key={index}
                                                                                                            style={halfIconDynamicStyle(item?.rating)}
                                                                                                        ></i>
                                                                                                    );
                                                                                                })}
                                                                                            </div>
                                                                                        </div>
                                                                                        {item?.subtitle && (
                                                                                            <span className="subtitle">
                                                                                                â€œ Outstanding Course â€
                                                                                            </span>
                                                                                        )}
                                                                                        {item?.description && <p>{item?.description}</p>}
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        )
                                            :
                                            <></>
                                        }

                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-xl-4 col-lg-5">
                                <EBookInfo data={ebookItem} activeStatus={type} />
                                <EBookWidget currentEBook={ebookItem} classes="mt--20" />
                                <InterviewRelatedSeries isFromWidget={true} heading="Series You May Like" currentSeries={seriesName} classes="mt--20" />
                                <ReusableWidget data={latestVideosData} title="Latest Videos" href="https://www.youtube.com/@LongswitchAcademy/videos" onVideoToggle={handleVideoToggle} onOpenDrawer={handleOpenDrawer} classes="mt--20" />
                                <ReusableWidget data={popularVideosData} title="Popular Videos" href="https://www.youtube.com/@LongswitchAcademy/videos" onVideoToggle={handleVideoToggle} onOpenDrawer={handleOpenDrawer} classes="mt--10" />
                                <ReusableWidget data={popularShortsVideosData} title="Popular Shorts Videos" href="https://www.youtube.com/@LongswitchAcademy/shorts" onVideoToggle={handleVideoToggle} onOpenDrawer={handleOpenDrawer} classes="mt--10" />

                            </div>
                        </div>

                    </div>
                </div>
                <div className="video-lightbox-wrapper">
                    <FsLightbox
                        toggler={toggler}
                        sources={[videoUrl]}
                        maxYoutubeVideoDimensions={
                            { width: 1920, height: 1080 }
                        }
                    />
                </div>

                {selectedItem && (
                    <GalleryDrawer
                        show={openDrawer}
                        classes={null}
                        onClose={handleHideDrawer}
                        data={selectedItem}
                        onVideoToggle={handleVideoToggle}
                        title={"Salesforce Tutorials Info"}
                        isLoading={galleryLoading}
                    />
                )}
            </Layout>
        </>
    );
};
export default EBookDetails;
